import { defineComponent as _defineComponent } from 'vue'
import { BKCheckinButton } from '@/features/checkin'
import { getDateRangeFormatted, getTimeRangeFormatted } from '@/services/date'
import {
  mdiCalendarMonth,
  mdiChevronDown,
  mdiChevronUp,
  mdiClockOutline,
  mdiCurrencyUsd,
  mdiLink,
  mdiMapMarkerRadius,
} from '@mdi/js'
import { IEvent } from '@/enitites/event'
import { computed, ref } from 'vue'
import { useVuetify } from '@/services/useVuetify'
// @ts-expect-error Not a ts file
import store from '@/store'
import PurchaseTicketsButton from '@/features/tickets/ui/PurchaseTicketsButton.vue'
import EventPayoutTrigger from '@/pages/EventPage/ui/EventPayoutTrigger.vue'
import EventFeedbackBlock from './EventFeedbackBlock.vue'
import EventFeedbackBlockAdmin from './EventFeedbackBlockAdmin.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventSidebar',
  props: {
    event: null
  },
  emits: ["update:event", "reload:event"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:event', updatedEvent: IEvent): void
  (e: 'reload:event'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  event: IEvent
};

const DisplayModeModal = () => import('@/enitites/display-mode/components/DisplayModeModal.vue')

const vuetify = useVuetify()
const isTabletDesktop = computed(() => vuetify.breakpoint.mdAndUp)




const getUserDB = computed(() => store.getters.getUserDB)

const isCollapsed = ref(true)
const date = computed(() => getDateRangeFormatted(props.event.dateStart, props.event.dateEnd, false))
const time = computed(() => getTimeRangeFormatted(props.event.dateStart, props.event.dateEnd))
const showFrontdesk = computed(
  () => props.event.permissions.canEdit || props.event.staff.hosts?.some(({ id }) => id === getUserDB.value?.id)
)

function handleMobileInfoToggle() {
  isCollapsed.value = !isCollapsed.value
}

return { __sfc: true,DisplayModeModal, vuetify, isTabletDesktop, props, emit, getUserDB, isCollapsed, date, time, showFrontdesk, handleMobileInfoToggle, BKCheckinButton, mdiCalendarMonth, mdiChevronDown, mdiChevronUp, mdiClockOutline, mdiCurrencyUsd, mdiLink, mdiMapMarkerRadius, PurchaseTicketsButton, EventPayoutTrigger, EventFeedbackBlock, EventFeedbackBlockAdmin }
}

})